<template>
  <div class="not-permission">
    <div style="margin-top: 10px;float: right">
      <el-button
        type="primary"
        round
        size="mini"
        @click="exitSystem"
      >
        {{ $t('login.logOut') }}
      </el-button>
    </div>
    <div style="clear: both;" />
    <div class="content">
      <div class="permission-image f-l">
        <img src="../assets/403.png" alt="err">
      </div>
      <div class="permission-text f-l">
        <template class="loginInfo">
          <div>
            <span v-if="userAuth.userName != null && userAuth.userId != null" />
            {{ userAuth.userName }}
            {{ userAuth.userId }}
            <br>
            {{ $t('login.accessPermissions') }}
          </div>
        </template>
        <div>
          <p class="title">If you have any questions, please contac：</p>
          <template v-if="contactShow">
            <p class="title">technical support:Jingtian Hao</p>
          </template>
          <template v-else>
            <p>Business Support: Please contact the corresponding sales/channel manager</p>
          </template>
          <p v-if="!contactShow" class="title">
            If the sub account login prompts no permission, please contact the main account 
            to confirm if the configurator permission has been enabled.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import Cookies from 'js-cookie';
import { removeAllCookie } from '../utils/loginOut';
export default {
  name: 'Error403',
  data () {
    return {
      contactShow: true,
      userAuth: {
        userId: '',
        userName: '',
        externalSysrolerRelation: ''
      }
    };
  },
  mounted () {
    this.linkman();
    // this.getUserAuth();
  },
  methods: {
    linkman () {
      let backURL = window.location.href;
      if (backURL.indexOf('wpcpartnertest.ruijie') !== -1 || backURL.indexOf('wpcpartner.ruijie') !== -1) {
        this.contactShow = false;
      } else if (backURL.indexOf('wpc.ruijie') !== -1) {
        this.contactShow = true;
      }
    },
    getUserAuth () {
      api.getUserAuth({ params: { type: 'Hr' } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.userAuth = json.data;
        } else {
          // 修改失败
          this.$notify.error(json.data);
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    exitSystem () {
      this.$confirm('Do you want to exit this system ?', 'message', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
       
        document.cookie = 'phplogin=; max-age=0; domain=.ruijie.com.cn;path=/';
        document.cookie = 'PartnerUser=; max-age=0; domain=.ruijie.com.cn;path=/';
        document.cookie = 'ruijieportal=; max-age=0; domain=.ruijie.com.cn;path=/';
        Cookies.set('phpLogin_prod', '');
        Cookies.set('phplogin', '');
        Cookies.set('PartnerUser', '');
        Cookies.set('ruijieportal', '');
        Cookies.set('ruijieportal_prod', '');
        Cookies.set('user_id', '');
        Cookies.set('uid', '');
        Cookies.set('PartnerUser_prod', '');

        Cookies.remove('phpLogin_prod');
        Cookies.remove('phplogin');
        Cookies.remove('PartnerUser');
        Cookies.remove('ruijieportal');
        Cookies.remove('ruijieportal_prod');
        Cookies.remove('user_id');
        Cookies.remove('uid');
        Cookies.remove('PartnerUser_prod');
        removeAllCookie();
        // 退出系统跳转登录页
        let backURL = window.location.href;
        // console.log(backURL);
        // window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
        if(window._env_.NODE_ENV === "pro") {
  window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
      backURL
    )}`;
        } else {
            window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
      backURL
    )}`;
        }
      
        
      }).catch(() => {

      });
    }
  }
};
</script>

<style type="text/css" scoped>
  .not-permission{
    width: 100%;
    height: 100%;
  }

  .not-permission .content{
    width: 1000px;
    margin: 150px auto;
  }

  .not-permission .content .permission-image{
    width: 500px;
  }

  .not-permission .content .permission-image img{
    width: 100%;
  }

  .f-l{
    float: left;
  }

  .not-permission .content .permission-text div:nth-of-type(1){
    font-size: 26px;
  }

  .not-permission .content .permission-text .title{
    font-size: 18px;
    margin-top: 16px;
  }

  .not-permission .content .permission-text div:nth-of-type(2) span p:nth-of-type(1){
    margin-top: 16px;
    margin-left: 30px;
  }
  .not-permission .content .permission-text div:nth-of-type(2) span p:nth-of-type(2){
    margin-top: 16px;
    margin-left: 30px;
  }

  .not-permission .content .permission-text{
    padding-top: 120px;
    padding-left: 20px;
    width: 500px;
  }
  .not-permission .content .permission-text .loginInfo{
    font-size: 18px;
    font-weight: bold;
  }

</style>
